import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { gettingStates } from "../../../function/other";
import { ExpenseContext } from "../../../pages/main/expense/add update expense";
import InputDateForm from "../../../shared components/DateInput/InputDateForm";
import DropdownOne from "../../../shared components/Dropdown/DropdownOne";
import DropdownTwo from "../../../shared components/Dropdown/DropdownTwo";
import InputError from "../../../shared components/InputError/InputError";
import InputField from "../../../shared components/TextInput";
import { AiOutlineReload } from "react-icons/ai";
import { MainContext } from "../../../utils/private_routes/PrivateRoutes";

const Form = () => {
  const { documentSetting } = useContext(MainContext);
  const {
    expenseId,
    loading,
    formik,
    vendorList,
    vendorloading,
    clientList,
    getDocNumber,
  } = useContext(ExpenseContext);

  const [states, setStates] = useState<string[]>([]);

  useEffect(() => {
    setStates(gettingStates("IN"));
  }, []);

  return (
    <>
      <div className="container-fluid px-4">
        <div
          className="row py-2"
          style={{
            backgroundColor: "var(--bg_color5)",
            borderRadius: "8px",
          }}
        >
          <div className="col-12 col-lg-6">
            <div className="mb-3">
              <DropdownTwo
                label="Vendor Name*"
                placeholder="Select vendor"
                name="vendorName"
                data={vendorList}
                state={formik.values.vendorName}
                setState={(e?: string, x?: string | number) => {
                  formik.setFieldValue("vendorName", e);
                  formik.setFieldValue("vendor", x);
                }}
                isDisabled={expenseId ? true : false}
                labelField="name"
                onBlur={() => formik.setFieldTouched("vendorName", true)}
              />
              {formik.touched.vendorName && formik.errors.vendorName ? (
                <InputError error={formik.errors.vendorName} />
              ) : null}
            </div>

            {vendorloading ? (
              <Skeleton width="120px" borderRadius={4} />
            ) : (
              formik.values.placeOfSupply && (
                <>
                  <div>
                    <p className="mb-0 font12x400 textColor3">
                      <span className="font12x600 textColor3">GSTIN: </span>
                      {formik.values.gstNo}
                    </p>
                  </div>

                  <div className="my-3">
                    <DropdownOne
                      label="Place of Supply*"
                      placeholder="Place of supply"
                      name="placeOfSupply"
                      data={states}
                      state={formik.values.placeOfSupply}
                      setState={(e?: string, x?: string | number) => {
                        formik.setFieldValue("placeOfSupply", e);
                      }}
                      onBlur={() =>
                        formik.setFieldTouched("placeOfSupply", true)
                      }
                    />
                    {formik.touched.placeOfSupply &&
                    formik.errors.placeOfSupply ? (
                      <InputError error={formik.errors.placeOfSupply} />
                    ) : null}
                  </div>
                </>
              )
            )}
          </div>
          <div className="col-12 col-lg-6">
            {vendorloading ? (
              <Skeleton width="200px" borderRadius={4} />
            ) : (
              formik.values.vendorAddress && (
                <div>
                  <p className="mb-0 font12x600 textColor3 mb-0 mb-lg-2">
                    Billing Address:
                  </p>
                  <p className="mb-0 font12x400 textColor3">
                    {vendorloading ? (
                      <Skeleton width="200px" borderRadius={4} />
                    ) : (
                      formik.values.vendorAddress
                    )}
                  </p>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      <div className="container-fluid mt-3 px-3">
        <div className="row">
          <div className="mb-3 col-12 col-lg-6">
            <label
              htmlFor="number"
              className="form-label font12x400 textColor3 mb-1"
            >
              Expense No*
            </label>
            <div className="input-group">
              {!expenseId && (
                <div className="input-group-text font12x600 border-0">
                  {documentSetting?.expense?.initials !== ""
                    ? `${documentSetting?.expense?.initials}/`
                    : ""}
                </div>
              )}
              <input
                type="text"
                className="form-control shadow-none font12x600 border-0"
                id="number"
                value={formik.values.number}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={expenseId ? true : false}
                style={{
                  cursor: expenseId ? "no-drop" : "unset",
                  backgroundColor: expenseId ? "#f2f2f2" : "#fff",
                  color: expenseId ? "#9C9E9C" : "var(--text3)",
                }}
              />
            </div>
            <div className="d-flex justify-content-between align-items-center">
              {formik.touched.number && formik.errors.number ? (
                <InputError error={formik.errors.number} />
              ) : null}
              {formik.touched.number && formik.errors.number ? (
                <AiOutlineReload
                  className="cursor_pointer"
                  onClick={() => getDocNumber({ f: "expense" })}
                />
              ) : null}
            </div>
          </div>
          <div className="mb-3 col-12 col-lg-6">
            <InputDateForm
              id="date"
              label="Expense Date*"
              type="date"
              state={moment(formik.values.date).format("YYYY-MM-DD")}
              setState={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.date && formik.errors.date ? (
              <InputError error={formik.errors.date} />
            ) : null}
          </div>
        </div>
        <div className="row">
          <div className="mb-3 col-12 col-lg-6">
            <InputDateForm
              id="dueDate"
              label="Due Date*"
              type="date"
              state={moment(formik.values.dueDate).format("YYYY-MM-DD")}
              setState={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.dueDate && formik.errors.dueDate ? (
              <InputError error={formik.errors.dueDate} />
            ) : null}
          </div>
          <div className="mb-3 col-12 col-lg-6">
            <InputField
              id="invoiceNumber"
              label="Invoice No"
              type="text"
              state={formik.values.invoiceNumber}
              setState={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.invoiceNumber && formik.errors.invoiceNumber ? (
              <InputError error={formik.errors.invoiceNumber} />
            ) : null}
          </div>
        </div>
        <div className="row">
          <div className="mb-3 col-12 col-lg-6">
            <DropdownTwo
              label="Client Reference"
              placeholder="Select client"
              name="clientName"
              data={clientList}
              state={formik.values.clientName}
              setState={(e?: string, x?: string | number) => {
                formik.setFieldValue("clientName", e);
                formik.setFieldValue("clientReference", x);
              }}
              labelField="name"
              onBlur={() => formik.setFieldTouched("clientName", true)}
            />
            {formik.touched.clientName && formik.errors.clientName ? (
              <InputError error={formik.errors.clientName} />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default Form;
